<script setup lang="ts">
import type { SidebarProps } from '@/components/ui/sidebar'

import {
  AudioWaveform,
  BookOpen,
  Bot,
  Command,
  Frame,
  GalleryVerticalEnd,
  PieChart,
  SquareTerminal,
  Users,
  Inbox,
  Calendar,
  Megaphone,
  FileText,
  Landmark,
  HandCoins,
  BarChart3,
  ShieldCheck,
  Settings2,
  Map,
} from "lucide-vue-next"
import NavMain from '@/components/NavMain.vue'
import NavProjects from '@/components/NavProjects.vue'
import NavUser from '@/components/NavUser.vue'
import TeamSwitcher from '@/components/TeamSwitcher.vue'

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/sidebar'

const props = withDefaults(defineProps<SidebarProps>(), {
  collapsible: "icon",

})


import {useAuth} from "@/stores/auth.ts";

const auth = useAuth()

const data = {
  user: {
    name: auth.user?.name,
    email: auth.user?.email,
    avatar: "/avatars/shadcn.jpg",
  },
  teams: [
    { name: "Gabinete", logo: Landmark, plan: "Mandato" },
    { name: "Campanha", logo: Megaphone, plan: "2024" },
  ],
  navMain: [
    {
      title: "Dashboard",
      url: "#",
      icon: SquareTerminal,
      isActive: true,
      items: [
        { title: "Resumo", url: "#" },
        { title: "Votos", url: "#" },
        { title: "Alertas", url: "#" },
      ],
    },
    {
      title: "Base",
      url: "#",
      icon: Users,
      items: [
        { title: "Contatos", url: "contacts" },
        { title: "Tarefas", url: "tasks" },
        { title: "Demandas", url: "#" },
        { title: "Agenda", url: "#" },
      ],
    },
    {
      title: "Comunicação",
      url: "#",
      icon: Megaphone,
      items: [
        { title: "Campanhas", url: "#" },
        { title: "Redes", url: "#" },
        { title: "Chatbot", url: "#" },
      ],
    },
    {
      title: "Gabinete",
      url: "#",
      icon: FileText,
      items: [
        { title: "Ofícios", url: "#" },
        { title: "Projetos", url: "#" },
        { title: "Financeiro", url: "#" },
      ],
    },
    {
      title: "Campanha",
      url: "#",
      icon: HandCoins,
      items: [
        { title: "Metas", url: "#" },
        { title: "Voluntários", url: "#" },
        { title: "Doações", url: "#" },
        { title: "Desempenho", url: "#" },
      ],
    },
    {
      title: "Inteligência",
      url: "#",
      icon: BarChart3,
      items: [
        { title: "Analytics", url: "#" },
        { title: "Transparência", url: "#" },
      ],
    },
    {
      title: "Configurações",
      url: "#",
      icon: Settings2,
      items: [
        { title: "Usuários", url: "#" },
        { title: "Integrações", url: "#" },
        { title: "Segurança", url: "#" },
        { title: "Modo", url: "#" },
      ],
    },
  ],
  projects: [
    { name: "Mapas", url: "maps", icon: Map },
    { name: "Leis", url: "#", icon: FileText },
    { name: "Digitais", url: "#", icon: Megaphone },
  ],
}

</script>

<template>
  <Sidebar v-bind="props">
    <SidebarHeader>
      <TeamSwitcher :teams="data.teams" />
    </SidebarHeader>
    <SidebarContent>
      <NavMain :items="data.navMain" />
      <NavProjects :projects="data.projects" />
    </SidebarContent>
    <SidebarFooter>
      <NavUser :user="data.user" />
    </SidebarFooter>
    <SidebarRail />
  </Sidebar>
</template>
